module.exports = __webpack_public_path__ + "static/flags/CG-d3fd5f26aea91f612b59caf512107599.gif";